"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
/**
 * Provide a `title` as an accessible label intended for screen readers.
 */
var Icon = function (_a) {
    var name = _a.name, className = _a.className, title = _a.title;
    return (React.createElement(React.Fragment, null,
        React.createElement("svg", { className: "icon icon-" + name + " " + (className || ''), "aria-hidden": "true" },
            React.createElement("use", { href: "#icon-" + name })),
        title &&
            React.createElement("span", { className: "visuallyhidden" }, title)));
};
exports["default"] = Icon;
